import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, API, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios, dayjs, FORMAT_DATE_API, MissingDay } from '@umanforge/common';


export class MissingDayService {

  static getMissingDaysByUser(
    userId: UUID, page: number, step: number,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<{ total: number, datas: MissingDay[] }> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.MISSING_DAYS}/by_user/${ userId }`, { ...await CommonGlobalService.getHeaderRequest( token ), params: { page, step } } )
        .then( ( response: AxiosResponse<{ total: number, datas: MissingDay[] }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static isValidMissingDaysForUser(
    userId: UUID, missingDays: { startDate: dayjs.Dayjs, endDate: dayjs.Dayjs }[], excludedMissingDaysId: UUID[],
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<boolean> {
    return new Promise( async resolve => {
      const formatedDates = missingDays.map( dates => {
        return { startDate: dates.startDate.format( FORMAT_DATE_API ), endDate: dates.endDate.format( FORMAT_DATE_API ) };
      } );
      AXIOS.get( API.MISSING_DAYS + '/is-valid-missing-day-for-user/' + userId, { ...await CommonGlobalService.getHeaderRequest( token ), params: { missingDays: formatedDates, excludedMissingDaysId } } )
        .then( ( response: AxiosResponse<{ isValidDates: boolean }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data.isValidDates );
        } )
        .catch( ( err: AxiosError ) => {
          if ( onError ) {
            onError( err );
          }
          GlobalService.onAxiosError( err, dispatch );
          resolve( false );
        } );
    } );
  }

};